import React, { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { LuBookOpen } from "react-icons/lu";

const SourceAccordion = ({ sources }) => {
  const [isOpen, setIsOpen] = useState(false);   // 기본은 닫힘 (토글로 펼침)

  // sources가 없거나 비어있으면 아무것도 안 그림
  if (!sources || sources.length === 0) return null;

  // 확장자 제거(표시용): 마지막 .확장자만 제거
  const stripExt = (name) => name.replace(/\.[^/.]+$/, '');
  // 참조된 문서명 — 확장자 제거 후 표시명 기준으로 중복 제거(동명 파일은 1개만)
  const docNames = [...new Set(sources.map((s) => s.id).filter(Boolean).map(stripExt))];
  // 태그는 첫 번째 참고 청크의 키워드만 노출
  const firstKeywords = sources[0]?.keywords || [];

  return (
    <div className="mt-4 border-t border-gray-100 pt-4 select-none">
      {/* 1. 키워드 태그 — 답변 바로 하단, 항상 표시 (첫 번째 청크 키워드) */}
      {firstKeywords.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {firstKeywords.map((kw, i) => (
            <span
              key={i}
              className="text-[15px] text-main-point bg-bg-main px-2 py-0.5 rounded-full shadow-sm"
            >
              #{kw}
            </span>
          ))}
        </div>
      )}

      {/* 2. '참고한 내역' 토글 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-[15px] text-gray-500 hover:text-main-point transition-colors py-1 focus:outline-none"
      >
        <LuBookOpen size={14} />
        <span>참고한 내역 {docNames.length}건</span>
        {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
      </button>

      {/* 3. 열렸을 때: 참조 문서명 목록만 (전체, 확장자 제외) */}
      {isOpen && (
        <div className="mt-2 bg-bg-main p-3 rounded-xl animate-fadeIn">
          <ul className="grid gap-1">
            {docNames.map((name, idx) => (
              <li key={idx} className="flex items-center gap-2 text-[15px] text-gray-700">
                <LuBookOpen size={12} className="text-gray-400 shrink-0" />
                <span className="break-all">{name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SourceAccordion;